if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      if (this.modalContent) this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      const spinner = opener.querySelector('.loading-overlay__spinner');
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          
          if (!this.productElement) {
            console.error('QuickAdd: Could not find MainProduct section');
            return;
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .catch(err => console.error('QuickAdd Error:', err))
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attr => newScriptTag.setAttribute(attr.name, attr.value));
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      // Safely find the container
      const variantContainer = this.modalContent.querySelector('variant-radios, variant-selects');
      if (variantContainer) {
        variantContainer.setAttribute('data-update-url', 'false');
      }

      // Safe jQuery check
      if (typeof jQuery !== 'undefined') {
        const colorInputs = $('input:radio[name="Color"]');
        colorInputs.off('click').on('click', function() {
          colorInputs.next('.swatch-element').removeClass('clicked');
          $(this).next('.swatch-element').addClass('clicked');
        });
      }
    }

    removeDOMElements() {
      const pickup = this.productElement.querySelector('pickup-availability');
      if (pickup) pickup.remove();

      const modal = this.productElement.querySelector('product-modal');
      if (modal) modal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;

      // Use a regex for global replacement to avoid accidental partial matches
      const regex = new RegExp(sectionId, 'g');
      this.productElement.innerHTML = this.productElement.innerHTML.replace(regex, `quickadd-${sectionId}`);
      
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((el) => {
        el.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (galleryList) {
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }

      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');
      if (FBT) FBT.remove();
      
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
    }
  });
}